import React, { useState } from "react";
import { Input, Modal } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FiAlertCircle, FiInfo, FiPrinter, FiX } from "react-icons/fi";
import { isUrdu } from "../../../constants/const";
import { Toggle } from "./ReportControls";

const PrintReportModal = ({ isOpen, onClose, onPrint, defaultTitle, filterSummary, columnCount, selectedCount, totalCount }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState(defaultTitle);
  const [showFilters, setShowFilters] = useState(true);
  const [selectedOnly, setSelectedOnly] = useState(false);
  const [error, setError] = useState(false);

  const handleOpened = () => {
    setTitle(defaultTitle);
    setSelectedOnly(false);
    setError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      setError(true);
      return;
    }
    onPrint({ title: title.trim(), showFilters, selectedOnly: selectedOnly && selectedCount > 0 });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} onOpened={handleOpened} className="mr-modal" centered>
      <form onSubmit={handleSubmit}>
        <div className="mr-modal-head">
          <span className="mr-icon-tile mr-tone-sky">
            <FiPrinter size={20} />
          </span>
          <div>
            <h3>{t("member_report_print_title")}</h3>
            <p>{t("member_report_print_hint", { value: columnCount })}</p>
          </div>
          <button type="button" className="mr-close" onClick={onClose} aria-label={t("common_cancel")}>
            <FiX size={16} />
          </button>
        </div>
        <div className="mr-modal-body">
          <div className="mr-field">
            <label htmlFor="mr-print-title">{t("member_report_report_title")}</label>
            <div className={"mr-input" + (error ? " mr-err" : "")}>
              <Input
                id="mr-print-title"
                autoFocus
                value={title}
                className={isUrdu(title) ? "ur" : ""}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setError(false);
                }}
              />
            </div>
            {error && (
              <div className="mr-err-msg">
                <FiAlertCircle size={13} /> {t("member_report_title_required")}
              </div>
            )}
          </div>
          <Toggle
            on={showFilters}
            onChange={setShowFilters}
            title={t("member_report_print_show_filters")}
            hint={filterSummary}
          />
          <Toggle
            on={selectedOnly && selectedCount > 0}
            disabled={selectedCount === 0}
            onChange={setSelectedOnly}
            title={t("member_report_print_selected_only")}
            hint={t("member_report_n_of_total_rufqa", { on: selectedCount, total: totalCount })}
          />
          <div className="mr-info">
            <FiInfo size={15} style={{ marginTop: 4 }} />
            <span>{t("member_report_print_info")}</span>
          </div>
        </div>
        <div className="mr-modal-foot">
          <button type="button" className="mr-btn mr-btn-ghost" onClick={onClose}>
            {t("common_cancel")}
          </button>
          <button type="submit" className="mr-btn mr-btn-primary">
            <FiPrinter size={14} /> {t("common_print")}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default PrintReportModal;
